/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import apiEndpoints from '../lib/apiEndpoints';
import apiCall from './apiCall';
// import config from '../config';

export const getMerchantProfile = (payload) => {
    return apiCall({
        method: 'get',
        endpoint: apiEndpoints.MERCHANT_PROFILE,
        query: {
          ...payload,
        },
      });
};

export const updateMerchantProfile = (payload) => {
    return apiCall({
        method: 'post',
        endpoint: apiEndpoints.MERCHANT_PROFILE,
        payload
      });
};

export const getStateApi = (countryCode:string) => {
  return apiCall({
      method: 'get',
      endpoint: apiEndpoints.GET_STATE(countryCode),
    });
};

export const getCityApi = (statecode:string) => {
  return apiCall({
      method: 'get',
      endpoint: apiEndpoints.GET_CITY(statecode),
    });
};
export const getIfsc = (ifsc) => {
  return apiCall({
      method: 'get',
      endpoint: apiEndpoints.GET_IFSC(ifsc),
    });
};

export const getSignzyToken = () => {
  return apiCall({
      method: 'get',
      endpoint: apiEndpoints.GET_SIGNZY_TOKEN,
    });
};

export const getPanToGSTList = (payload, authParams) => {
  return apiCall({
    method: 'post',
    endpoint: apiEndpoints.GET_PAN_TO_GSTLIST(authParams.userId),
    signzy_token: authParams.id,
    isSignzyEndPoint: true,
    payload
  });
};

export const getPanVerifyApi = (payload, authParams) => {
  return apiCall({
    method: 'post',
    endpoint: apiEndpoints.GET_PAN_VERIFY(authParams.userId),
    signzy_token: authParams.id,
    isSignzyEndPoint: true,
    payload
  });
};

export const getBankVerifyApi = (payload, authParams) => {
  return apiCall({
    method: 'post',
    endpoint: apiEndpoints.GET_BANK_VERIFY(authParams.userId),
    signzy_token: authParams.id,
    isSignzyEndPoint: true,
    payload
  });
};

export const verifyKYCApi = (payload) => {
  return apiCall({
    method: 'post',
    endpoint: apiEndpoints.GET_VERIFY_KYC,
    payload
  });
};

export const kycFormSubmitApi = (payload, authParams) => {
  return apiCall({
    method: 'post',
    endpoint: apiEndpoints.SALESFORCE_FORM2,
    isSalesForceEndPoint: true,
    customOrigin: authParams.instance_url,
    sf_access_token: authParams.access_token,
    sf_token_type: authParams.token_type,
    payload
  });
};

export const kycFormReSubmitApi = (payload, authParams) => {
  return apiCall({
    method: 'post',
    endpoint: apiEndpoints.SALESFORCE_RESUBMIT,
    isSalesForceEndPoint: true,
    customOrigin: authParams.instance_url,
    sf_access_token: authParams.access_token,
    sf_token_type: authParams.token_type,
    payload
  });
};

export const updateAccountApi = (payload) => {
  return apiCall({
    method: 'post',
    endpoint: apiEndpoints.UPDATE_ACCOUNT,
    payload
  });
};

export const toggleEnvApi = () => {
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.TOGGLE_ENV,
    // customOrigin:config(process.env.REACT_APP_BUILD_ENV).API.API_BASE_URL
  });
};
